module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "pt-3"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-space-between": "",
      "pb-3": "",
      "px-3": ""
    }
  }, [_c('div', {
    staticClass: "layout row wrap"
  }, [_c('div', {
    staticClass: "pa-2"
  }, [_c('datetime', {
    staticClass: "datetime-btn primary--text",
    attrs: {
      "phrases": {
        ok: _vm.$lang.actions.ok,
        cancel: _vm.$lang.actions.cancel
      },
      "type": "datetime",
      "placeholder": _vm.$lang.labels.fromDate
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pa-2"
  }, [_c('datetime', {
    staticClass: "datetime-btn primary--text",
    attrs: {
      "phrases": {
        ok: _vm.$lang.actions.ok,
        cancel: _vm.$lang.actions.cancel
      },
      "type": "datetime",
      "placeholder": _vm.$lang.labels.toDate
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-2 my-2",
    on: {
      "click": function($event) {
        return _vm.showLogs()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.showLogs))])], 1), _vm._v(" "), _c('v-text-field', {
    staticClass: "min-w max-w mx-2",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), (_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    staticClass: "my-0",
    attrs: {
      "type": "error",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.logs,
      "search": _vm.search,
      "loading": _vm.loading,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.errorMessage))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-btn', {
          staticClass: "primary mx-0",
          on: {
            "click": function($event) {
              return _vm.showModal(props.item)
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.view))])], 1)]
      }
    }], null, false, 3518210434)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n            Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n          ")])], 1)], 1) : _vm._e()])], 1), _vm._v(" "), (_vm.viewLogModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "700"
    },
    model: {
      value: (_vm.viewLogModal),
      callback: function($$v) {
        _vm.viewLogModal = $$v
      },
      expression: "viewLogModal"
    }
  }, [_c('view-log-modal', {
    attrs: {
      "log": _vm.log
    },
    on: {
      "close": function($event) {
        _vm.viewLogModal = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-253f3170","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/systemLogs/SystemLogs.vue
// module id = 392
// module chunks = 35